import { Session } from '@36node/next-stargate';

import { RoleToPermissions } from './role';

export function getPermissionsFromSession(session?: Session) {
  const permissions = [...(session?.permissions || [])];
  session?.roles?.forEach((role) => {
    permissions.push(...(RoleToPermissions[role] ?? []));
  });
  return [...new Set(permissions)];
}
